import { Modal } from 'antd';
import Text from 'components/Text';
import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import styled from 'styled-components';

interface IConfig {
  title: string,
  description: string
}

export type SuccessModalRef = {
  open: (config: IConfig) => void;
  close: () => void;
};

export const useSuccessModalRef = () => React.createRef<SuccessModalRef>();
export const successModalRef = useSuccessModalRef();

const SuccessModal = forwardRef<SuccessModalRef>((_, ref) => {
  const [open, setOpen] = useState(false);
  const [config, setConfig] = useState<IConfig>();

  const handleOpen = (config: IConfig) => {
    setConfig(config);
    setOpen(true);
  };

  useImperativeHandle(ref, () => ({
    open: handleOpen,
    close: () => setOpen(false),
  }));

  if (!open) return null;

  return (
    <ModalStyled
      open
      width={420}
      title=''
      closeIcon={null}
      footer={null}
      onClose={() => setOpen(false)}
      styles={{
        header: { display: 'none' },
        content: { borderRadius: 24 },
        body: { padding: 0 }
      }}
    >
      <ContentWrapper>
        <IconSuccess />

        <Text variant='H1'>
          {config?.title ?? 'Thank You!'}
        </Text>

        <Text variant='H6'>
          {config?.description ?? 'Your appointment has been successfully booked.'}
        </Text>

        <CloseButton onClick={() => setOpen(false)}>
          <Text variant='H7' color='#5C6D8A'>CLOSE</Text>
        </CloseButton>
      </ContentWrapper>
    </ModalStyled>
  );
});

SuccessModal.displayName = 'SuccessModal';
export default SuccessModal;

const ModalStyled = styled(Modal)`
  .ant-modal-content {
    border-radius: 32px;
  }
`;

const ContentWrapper = styled.div`
  padding: 48px 32px;
  text-align: center;
  background: #FFFFFF;
  border-radius: 32px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 32px;
`;


const CloseButton = styled.button`
  width: 100%;
  height: 56px;
  border-radius: 40px;
  border: none;
  background: #d1d5db;
  cursor: pointer;
`;

const IconSuccess = () => {
  return (
    <svg width='96' height='96' viewBox='0 0 96 96' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='96' height='96' rx='48' fill='#DCFCE7'/>
      <path d='M34 50L42 58L62 38' stroke='#22C55E' strokeWidth='6' strokeLinecap='round' strokeLinejoin='round'/>
    </svg>
  );
};